import './App.css';
import Hero from './Components/Hero';
import Header from './Components/Header'

function App() {
  return (
    <div className="App custom-cursor">
      <Hero />
      <Header/>
    </div>
  );
}

export default App;
